import { useAppContext } from '../lib/AppContext';
import { useRouter } from '../router';

/**
 * Organiser branding header - shown on every page of this checkout app. Previously there was no
 * header at all (confirmed: `App.tsx`'s `Shell` rendered straight into page content), so a
 * tenant's `theme.logoUrl`/`theme.displayName` - already resolved at runtime per tenant - never
 * appeared anywhere, even though the checkout runtime config has always carried them.
 */
export function Header() {
  const { config } = useAppContext();
  const { navigate } = useRouter();
  const { logoUrl, displayName } = config.theme;
  const { organiserWebsiteUrl } = config;

  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:px-6 flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => navigate({ name: 'events' })}
          className="flex items-center gap-3 focus-ring rounded-brand"
        >
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={displayName}
              className="h-10 w-auto max-w-[180px] object-contain"
            />
          ) : null}
          <span className="font-heading text-lg font-semibold text-slate-800">{displayName}</span>
        </button>
        {organiserWebsiteUrl && (
          <a
            href={organiserWebsiteUrl}
            className="text-sm font-medium text-slate-600 hover:text-slate-900 focus-ring rounded-brand whitespace-nowrap"
          >
            &larr; Back to website
          </a>
        )}
      </div>
    </header>
  );
}
